import Head from 'next/head';

import Footer from 'components/Footer';
import Header from 'components/Header';
import { Thanks } from 'components/SummitFlow/Thanks';

import { FC } from 'react';

const ThanksPage: FC = () => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>
    </Head>
    <Header />
    <Thanks />
    <Footer />
  </div>
);
export default ThanksPage;
